<template>
  <div class="task-box" :class="locale === 'en' ? 'localeEn' : 'localeZh'">
<div class="headTitleBox"><div class="headTitle">
      <div class="titleTips">{{ $t("DesignTask") }}</div>
      <a-button class="button-type5 " style="font-size: 16px" @click="hDownload" type="primary"
        :loading="data.isLoading">{{ data.isLoading ? $t("Downloading") : $t("Download") }}</a-button>
    </div></div>
  
    <div class="bgcKV">
      <!-- <div v-if="locale !== 'zh'" class="introduce-box">
      <div class="introduce-title">
        <div class="title4">12TH SAIC DESIGN CHALLENGE</div>
        <div class="title5">Electrifying Progress</div>
      </div>
      <a-button
        class="button-type5 button"
        style="font-size: 16px"
        @click="hDownload"
        type="primary"
        :loading="data.isLoading"
        >{{ data.isLoading ? $t("Downloading") : $t("Download") }}</a-button
      >
    </div> -->
      <!-- <div v-if="locale !== 'en'" class="introduce-video-box">
      <video-pc :videoSrc="props.videoSrc" />
    </div> -->
      <div v-if="locale !== 'en'" class="introduce-box">

        <div class="introduce-title">
          <div class="title1">「主赛道：汽车造型设计」</div>
          <img style="width:580px;height: 440px; margin-top: 10px;" src="@/assets/2026img/task/mainTrack.png" alt="" />
        </div>
      </div>

      <!-- <div class="advertising-img">
      <img :src="data.backgroundImage1" alt="" />
    </div> -->

      <!-- <div v-if="locale === 'zh'" class="introduce-title1">
      <div class="title1">作品提交内容及要求</div>
      <div class="title3">Submission Content and Requirements for Works</div>
    </div> -->

      <div v-if="locale === 'zh'" class="submission-content">
        <div class="theme-content">
          <div>
            从面向未来的想象，到拥抱多元共生，上汽设计国际挑战赛始终锚定真实世界的人本诉求。
          </div>
          <div>
            本届大赛以“共鸣”为核心，提出设计的新维度：
          </div>
          <div class="text-underline">
            与时代共鸣，回应当下的精神思考
          </div>
          <div class="text-underline" >
            与伙伴共鸣，发掘不同个体的频率
          </div>
          <div class="text-underline" > 
            与自我共鸣，成为回应情绪的容器
          </div>
          <div>
            请以‘感受力’洞察需求，以‘共情力’塑造体验，让汽车从出行工具，
          </div>
          <div>
            升级为承载情感、链接万物的移动载体
          </div>
        </div>
        <!-- <h4>提交材料：</h4> -->
        <div class=" requirement ">
          <div class="title1">作品提交内容及要求</div>
          <div class="title2">Submission Content and Requirements for Works</div>
        </div>
        <div class="item-box">

          <div>
            <span class="item-bold">1、车型平台限定： </span> <br />
            <span class="requirementTips">提交的作品需基于车身长度不得小于3500mm，不得大于5400mm。</span><br />
            <span class="requirementTips">（如果提交作品包含多款乘用车型，满足同平台尺寸变化范围）</span>
          </div>
        </div>
        <div class="item-box lineHeight">
          <div>
            <span class="item-bold">2、个人介绍：</span><br />
            <span class="requirementTips">100 秒自我介绍 MP4 视频*1，简历 pdf*1。</span><br />
            <span class="requirementTips">* 如有作品集可附带提交（不做强制要求）</span>
          </div>
        </div>
        <div class="item-box lineHeight">
          <div>
            <span class="item-bold">3、展示板面两张：</span><br />




            <span class="requirementTips"> A3幅面大小[420×297mm]、JPEG格式且分辨率不低于300DPI，排版形式横向排版；</span><br />
            <span class="requirementTips">内容中必须包含：草图展示，方案前后45度3D渲染效果图各一张，正视图及侧视图的车身布局(Package)一张。</span>
            <br />
            <span class="requirementTips">
              *设计作品需体现品牌（品牌选择：荣威、名爵、尚界）作品尺寸需满足以下条件：车身长度不得小于3500mm，不得大于5400mm。</span>
            <br />
            <span class="requirementTips">*展示板还可以展示：设计理念诠释、车身布局、概念草图、人机工程、细节设计等内容。（不做强制要求）</span>
          </div>
        </div>


        <div class="item-box lineHeight">
          <div>
            <span class="item-bold">4、3D 数字模型文件：</span><br />
            <span class="requirementTips">可接受的软件格式包括但不限于：Alias、Pro-E、UG、Catia、 Maya、 3D Max、 Rhino、Blender。</span>
          </div>
        </div>

      </div>

      <div v-if="locale === 'en'" class="submission-content">
        <h4>Submit contents:</h4>
        <div class="item-box">
          <p>
            <span class="item-bold">1-Intention:</span> Brief explanation story.
          </p>
        </div>
        <div class="item-box">
          <p><span class="item-bold">2-Moodboard:</span> supporting the story.</p>
        </div>
        <div class="item-box">
          <p>
            <span class="item-bold">3-3 views of the car:</span> Hand sketches +
            renders.
          </p>
        </div>
        <div class="item-box">
          <p><span class="item-bold">4-Quality requested:</span> A3, 72dpi.</p>
        </div>
        <div class="item-box">
          <p><span class="item-bold">5-New design,</span> never seen before.</p>
        </div>
        <div class="item-box">
          <p>
            *The dimensions must meet the following criteria: wheelbase no less
            than 2600mm and no greater than 3000mm; body length no less than
            3800mm and no greater than 5000mm.
          </p>
        </div>
        <img class="car-img" :src="data.backgroundImage2" alt="" @click="showFn(data.backgroundImage2)" />
        <p class="item-liner">Sub-track</p>
      </div>
      <div class="submission-content">

        <div v-if="locale === 'zh'" class="introduce-title1">
          <div class="title1">评审维度</div>
          <div class="title3">Evaluation Dimensions</div>
          <!-- <div class="title3">分赛道1:品牌战略与服务设计</div> -->
        </div>
        <span class="evaluationBox">
          <span>
            <span> 1、切题性40% </span>场评估作品与主题的契合度及思想深度
          </span>
          <span>
            <span>2、美观创新35% </span>
            评估作品的形式与审美表达
          </span>
          <span>
            <span>3、技能潜力25% </span>
            评估设计的合理性与未来价值
          </span>

        </span>


      </div>

      <div class="submission-content">
        <div v-if="locale === 'en'" class="introduce-title2">
          <div class="title4">Sub-track: Car digital visualization design</div>
          <div class="title5">Hyper Imagination</div>
        </div>
        <div v-if="locale === 'zh'" class="introduce-title2">
          <div class="title1">版权申明</div>
          <div class="title3">Copyright Statement</div>
        </div>
        <div class="item-box lineHeight">
          <span class="requirementTips">您需确保您的作品为原创作品，且未被授权给任何组织或个人商用（不论有偿或无偿）。</span><br />
          <span class="requirementTips">本次比赛不接受在其他比赛中投稿的作品参赛。</span><br />
          <span class="requirementTips">主办方对在本次大赛中所提供的所有参赛作品均享有合法使用权益，参赛者一旦参赛，则视为同意并授权主办方及其关联公司自投稿之日起至大赛结束以后无偿地在全球范围内将其投稿作品用于活动和产品、品牌宣传，包括但不限于将作品用于全媒体平台、艺术展会，零售店以及路演等营销活动，据此使用参赛作品时不需要再另行通知参赛者或征得参赛者的同意。</span><br />
   
          <span class="requirementTips">主办方及其关联公司有权基于以上目的授权合作方使用投稿作品。</span><br />
          <span class="requirementTips">获得全球一等奖，二等奖，三等奖，优秀奖，新星奖及最佳创意奖的参赛作品的版权。</span><br />
          <span class="requirementTips">（包括但不限于复制权、发行权、出租权、展览权等权利）转让给主办方，归主办方所有。</span><br />



          <img style="width:98px;height: 134px; margin-top: 40px;" src="@/assets/2026img/task/logo.png" alt="" />
        </div>

        <!-- <p class="submission-title">{{ $t("CompetitionText112") }}</p>
      <h4>{{ $t("CompetitionText113") }}</h4>
      <div class="ul-item-box">
        <p>{{ $t("CompetitionText114") }}</p>
      </div>
      <h4>{{ $t("CompetitionText115") }}</h4>
      <div class="ul-item-box">
        <p v-if="locale === 'en'">Entry submission</p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText116") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText117") }}</span
          ><span>{{ $t("CompetitionText118") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText119") }}</span
          ><span>{{ $t("CompetitionText120") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText121") }}</span
          ><span>{{ $t("CompetitionText122") }}</span>
        </p>
      </div>
      <h4>{{ $t("CompetitionText123") }}</h4>
      <div class="ul-item-box">
        <p>
          <span class="item-bold">{{ $t("CompetitionText124") }}</span
          ><span>{{ $t("CompetitionText125") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText126") }}</span
          ><span>{{ $t("CompetitionText127") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText128") }}</span
          ><span>{{ $t("CompetitionText129") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText130") }}</span
          ><span>{{ $t("CompetitionText131") }}</span>
        </p>
      </div>
      <h4>{{ $t("CompetitionText132") }}</h4>
      <div class="ul-item-box">
        <p>
          <span class="item-bold">{{ $t("CompetitionText133") }}</span
          ><span>{{ $t("CompetitionText134") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText135") }}</span
          ><span>{{ $t("CompetitionText136") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText137") }}</span
          ><span>{{ $t("CompetitionText138") }}</span>
        </p>
        <p>
          <span class="item-bold">{{ $t("CompetitionText139") }}</span
          ><span>{{ $t("CompetitionText140") }}</span>
        </p>
      </div> -->
      </div>

      <div>
        <div v-if="locale === 'en'" class="introduce-title3">
          <div class="title4">Design Strategy and Communication Sub-track</div>
          <div class="title5">Needs and Minds</div>
        </div>
        <div v-if="locale === 'zh'" class="introduce-title3">
          <div class="title1">「品牌与设计战略赛道」</div>
          <!-- <div class="title2">Needs and minds</div> -->
          <!-- <div class="title3">空间再定义</div>
        <div class="title3">Space in definition</div> -->
          <img style="width:580px;height: 232px; margin-top: 20px;" src="@/assets/2026img/task/year.png" alt="" />
          <div class="title2">请在以下两个命题中二选一完成</div>
        </div>

      </div>

      <div class="submission-content">

        <div v-if="locale === 'zh'" class="introduce-title4">
          <div class="title1">命题一：《荣威20年：与时代共鸣》</div>
          <p class="title2"> &nbsp;&nbsp;&nbsp;&nbsp;
            2006年，荣威诞生于中国汽车工业加速融入全球体系的起点；20年间，中国家庭结构、城市形态、技术范式与消费审美发生了根本性变化，从“拥有一辆车”，到“选择一种生活方式”，从“技术追赶”，到“价值表达”。品牌所承载的意义，正在被新一代用户重新定义。20年来，荣威在不断变化的社会与产业环境中发展成长，回应过不同阶段真实世界里用户的真实需求。<br />今天，随着消费观念与生活方式的演进，汽车品牌正面临一个新的课题——如何在功能与技术之外，与用户建立更深层次的情感与价值共鸣。
          </p>
          <div class="title1" style='margin-top: 40px; margin-bottom: 24px;'>你的任务：</div>
          <p class="title3 text-underline " style="  text-indent: 2em;"> 
            在荣威20周年之际，从品牌与设计战略的视角出发，重新理解荣威，并探索其在未来如何与新一代用户形成持续而真实的共鸣。请围绕“荣威20周年”这一时间节点，重点思考并回应以下方向： </p>
          <ul style="margin-left: 20px;">
            <li class="title3">你如何理解今天的荣威？它在中国汽车品牌格局中的位置，以及它与用户之间正在形成的品牌关系。 </li>
            <li class="title3">面对逐渐成为主力的年轻消费群体，荣威可以通过哪些价值主张、设计语言或产品体验，与他们建立共鸣？
              并且在品牌年轻化的过程中，哪些核心精神值得被延续？哪些表达方式需要更新，才能更好地被理解与认同？ </li>
            <li class="title3">面对当下的年轻一代用户需求，荣威品牌形象需要怎样进化？产品需要怎样进化？搭载的设计语言需要怎样进化？ </li>
          </ul>


          <div class=" requirement ">
            <div class="title1">作品提交内容及要求</div>
            <div class="title2">Submission Content and Requirements for Works</div>
          </div>
          <div class="item-box">

            <div>
              <span class="item-bold">1、作品要求： </span> <br />


              <span class="requirementTips"> 利用设计思维进行广泛的资料搜集、战略分析和用户研究，形成完整的品牌现状分析及未来发展的进化策略报告。</span><br />
              <span class="requirementTips">需要观点明确、资料全面、数据真实可靠，有实地调研成果；框架逻辑清晰、画面逻辑清晰，具有易读性和吸引力。鼓励运用跨学科工具与方法进</span>
              <span class="requirementTips">行问题定义与解决，可以适当应用AI工具可视化策略成果，不限于品牌VI及IP设计、门店空间设计、周边产品设计、产品设计语言。</span>
            </div>
          </div>
          <div class="item-box lineHeight">
            <div>
              <span class="item-bold">2、展示板面两张：</span><br />
              <span class="requirementTips"><span class="bold">1）个人介绍：</span>100秒自我介绍MP4视频*1，简历pdf*1
              </span><br />
              <span class="requirementTips"><span class="bold">2）研究报告：</span>PDF格式，16:9横向排版</span>
            </div>
          </div>
          <div class="item-box lineHeight">
            <div>
              <span class="item-bold">3、材料格式：</span><br />




              <span class="requirementTips">除个人介绍材料外，其余材料建议以16:9 PDF文件、JPEG文件、MP4文件提交（要求图片清晰，视频材料时长3分钟以内)</span><br />

            </div>
          </div>



        </div>

      </div>
      <div class="submission-content">

        <div v-if="locale === 'zh'" class="introduce-title4">
          <div class="title1">命题二：《尚界·Beyond the Car》</div>
          <p class="title2"> &nbsp;&nbsp;&nbsp;&nbsp;
          <span class="text-underline">在汽车产业高度同质化、产品技术快速迭代的当下，品牌的竞争正在从“产品本身”，延伸至“品牌如何进入用户的日常生活”</span>。对年轻一代消费者而言，品牌不再只是一次性的大宗消费选择，而是一个可以被持续感知、反复使用、主动分享的“生活伙伴”。<span class="text-underline">品牌周边作为一个重要的用户触点，是一种低门槛、高频次、强情绪密度的品牌表达媒介。</span>
          </p>
          <div class="title1" style='margin-top: 40px; margin-bottom: 24px;'>你的任务：</div>
          <div class="title3">&nbsp;&nbsp;&nbsp;&nbsp; 
           <span class="text-underline"> 从品牌战略与产品设计的双重维度出发，为「尚界」品牌打造一套品牌周边方案。通过具体的实物载体的设计，让用户触碰并拥有尚界的美学精神。</span> </div>
          <div class="title3" style="width: 100%;"> 请围绕以下核心方向展开思考与创作： </div>
          <ul style="margin-left: 23px;">
            <li class="title3"> <span class="bold">品牌基因提取与IP构建：</span> 深入挖掘尚界品牌的内核。你可以选择创造一个能够代表尚界精神的 <span class="text-underline">原创
              IP（形象或视觉符号），</span>并赋予其完整的人设、性格与世界观。 </li>
            <li class="title3"> <span class="bold">周边产品矩阵设计：</span>
              基于尚界品牌调性，设计一系列品牌周边产品。产品类别不限（如数码潮玩、生活文具、时尚配饰、出行装备等），但必须具备<span class="text-underline">可落地性</span>（需考虑材料工艺的可实现性与成本合理性）。 </li>

          </ul>


          <div class=" requirement ">
            <div class="title1">作品提交内容及要求</div>
            <div class="title2">Submission Content and Requirements for Works</div>
          </div>
          <div class="item-box">

            <div>
              <span class="item-bold">1、作品要求： </span> <br />


              <span class="requirementTips"> <span class="bold">1）品牌洞察报告：</span> 阐述你对尚界品牌的理解及目标人群画像。</span><br />
              <span class="requirementTips"><span class="bold">2）IP及视觉方案：</span> IP视觉形象、延展图形、色彩体系。</span><br />
              <span class="requirementTips"><span class="bold">3）周边设计方案：</span>
                至少包含3款不同品类的周边产品设计样稿（含效果图、材质说明及设计说明）。</span><br />
              <span class="requirementTips"><span class="bold">4）传播场景：</span> 简述这套周边在何种场景（如车展、快闪店、线上商城）中呈现最为合适。</span>
            </div>
          </div>
          <div class="item-box lineHeight">
            <div>
              <span class="item-bold">2、展示板面两张：</span><br />
              <span class="requirementTips"><span class="bold">1）个人介绍：</span>100秒自我介绍MP4视频*1，简历pdf*1
              </span><br />
              <span class="requirementTips"><span class="bold">2）研究报告：</span>PDF格式，16:9横向排版</span>
            </div>
          </div>
          <div class="item-box lineHeight">
            <div>
              <span class="item-bold">3、材料格式：</span><br />




              <span class="requirementTips">除个人介绍材料外，其余材料建议以16:9 PDF文件、JPEG文件、MP4文件提交（要求图片清晰，视频材料时长3分钟以内)</span><br />

            </div>
          </div>
          <div v-if="locale === 'zh'" class="requirement">
            <div class="title1">版权申明</div>
            <div class="title2" style="margin-bottom: 40px;">Copyright Statement</div>
          </div>
          <div class="item-box lineHeight">




            <span class="requirementTips">您需确保您的作品为原创作品，且未被授权给任何组织或个人商用（不论有偿或无偿）。</span><br />
            <span class="requirementTips">本次比赛不接受在其他比赛中投稿的作品参赛。</span><br />
            <span class="requirementTips">主办方对在本次大赛中所提供的所有参赛作品均享有合法使用权益，参赛者一旦参赛，则视为同意并授权主办方及其关联公司自投稿之日起至大赛结束以后无偿地在全球范围内将其投稿作品用于活动和产品、品牌宣传，包括但不限于将作品用于全媒体平台、艺术展会，零售店以及路演等营销活动，据此使用参赛作品时不需要再另行通知参赛者或征得参赛者的同意。</span><br />
            <span class="requirementTips">主办方及其关联公司有权基于以上目的授权合作方使用投稿作品。</span><br />
            <span class="requirementTips">获得全球一等奖，二等奖，三等奖，优秀奖，新星奖及最佳创意奖的参赛作品的版权。</span><br />
            <span class="requirementTips">包括但不限于复制权、发行权、出租权、展览权等权利）转让给主办方，归主办方所有。</span><br />



            <img style="width:98px;height: 134px; margin-top: 40px;" src="@/assets/2026img/task/logo.png" alt="" />
          </div>


        </div>

      </div>
      <div>

        <div v-if="locale === 'zh'" class="introduce-title3">
          <div class="title1">「CMF赛道」</div>
          <!-- <div class="title2">Needs and minds</div> -->
          <img style="width:580px;height: 232px; margin-top: 20px;" src="@/assets/2026img/task/year.png" alt="" />
          <div class="title2" style="font-weight: 700;">《2.5次元生活漫游——以 CMF 构建年轻人的随身次元结界》</div>
        </div>
        <div class="submission-content">
          <div v-if="locale === 'zh'" class="introduce-title4">

            <p class="title3"> &nbsp;&nbsp;&nbsp;&nbsp;
              在当代年轻文化语境中，二次元与三次元之间的界限正逐渐模糊。动画、美术风格与虚拟叙事不再局限于屏幕或特定圈层，而是以更加日常、轻量且去符号化的方式渗透进真实生活的物品与空间之中。“2.5
              次元”由此成为一种介于幻想与现实之间的生活状态——它并非对现实的逃离，而是在现实中为情绪留出一块理想化的缓冲空间。年轻消费者希望在高度理性、标准化的日常环境中，保留属于自己的轻松、愉悦与想象力片段，使生活本身具备被“观看”和“体验”的情绪价值。在这一背景下，汽车作为高度日常化的移动产品，其角色正在从单一的交通工具，转向年轻用户生活方式与情绪状态的重要载体。
            </p>
            <p class="title3"> &nbsp;&nbsp;&nbsp;&nbsp; <span class="text-underline"> 本命题以“2.5 次元生活漫游”为切入点，聚焦当代年轻消费者在现实生活中构建个人情绪空间的需求，探索汽车如何通过
              CMF（Color, Material, Finish）设计，成为承载轻松情绪与想象体验的移动场所。</span> </p>
            <p class="title3"> &nbsp;&nbsp;&nbsp;&nbsp; 不同于简单的二次元形象联动或表层风格移植，本命题强调在不依赖具体
              IP、不强化文化符号的前提下，通过色彩、材质、纹理与光影语言的系统设计，在真实工业产品中营造若隐若现的“次元提示”，让日常驾驶成为一段介于现实与幻想之间的漫游体验。 </p>

            <div class=" requirement ">
              <div class="title1">命题边界与设计原则</div>
              <div class="title2" >Proposition Boundaries & Design Principles</div>
              <div class="item-box">
                <div>
                  <span class="item-bold" style="margin-bottom: 10px !important; ">为确保命题的商业可行性与比赛导向的专业性，本命题强调以下原则： </span> <br />
                  <span class="requirementTips">1、设计应基于真实汽车制造体系与量产条件，避免脱离工业逻辑的过分概念化表达；</span><br />
                  <span class="requirementTips">2、不依赖具体二次元 IP、角色形象或明确文化符号，避免侵权风险；</span><br />
                  <span class="requirementTips">3、鼓励通过 CMF 系统设计实现整车层面的情绪一致性与长期价值。</span>
                </div>
              </div>
            </div>
            <div class=" requirement ">
              <div class="title1">作品提交内容及要求</div>
              <div class="title2">Submission Content and Requirements for Works</div>
            </div>
            <div class="item-box">

              <div>
                <span class="item-bold">1、个人介绍： </span> <br />


                <span class="requirementTips"> 个人简历pdf*1，个人作品集*1，100秒自我介绍MP4视频*1</span><br />

              </div>
            </div>
            <div class="item-box lineHeight">
              <div>
                <span class="item-bold">2、方案报告：</span><br />
                <span class="requirementTips">1份完整16:9报告，横向排版。包含主题阐释/目标人群分析/设计趋势/故事板/材质板/内外饰效果图
                </span>
              </div>
            </div>
            <div class="item-box lineHeight">
              <div>
                <span class="item-bold">3、创新材料，前沿技术：</span><br />
                <span class="requirementTips">在材料创新上体现可持续、低碳环保的理念，在作品中给出创新度高且具有可行性的材料设计说明</span>
              </div>
            </div>
             <div class="item-box lineHeight">
              <div>
                <span class="item-bold">4、展示视频：</span><br />
                <span class="requirementTips">要求提供展示CMF设计方案的视频，时长不超过2分钟，MP4格式，1920*1080，小于500M</span>
              </div>
            </div>
            <div class="item-box lineHeight">
              <div>
                <span class="subtitle">上述为基本的投稿要求，同时也鼓励大家采用更加丰富和多元的形式进行投稿。 </span>
              </div>
            </div>
             <div v-if="locale === 'zh'" class="requirement">
          <div class="title1">版权申明</div>
          <div class="title2" style="margin-bottom: 40px;">Copyright Statement</div>
        </div>
        <div class="item-box lineHeight">
          <span class="requirementTips">您需确保您的作品为原创作品，且未被授权给任何组织或个人商用（不论有偿或无偿）。</span><br />
          <span class="requirementTips">本次比赛不接受在其他比赛中投稿的作品参赛。</span><br />
          <span class="requirementTips">主办方对在本次大赛中所提供的所有参赛作品均享有合法使用权益，参赛者一旦参赛，则视为同意并授权主办方及其关联公司自投稿之日起至大赛结束以后无偿地在全球范围内将其投稿作品用于活动和产品、品牌宣传，包括但不限于将作品用于全媒体平台、艺术展会，零售店以及路演等营销活动，据此使用参赛作品时不需要再另行通知参赛者或征得参赛者的同意。</span><br />
          <span class="requirementTips">主办方及其关联公司有权基于以上目的授权合作方使用投稿作品。</span><br />
          <span class="requirementTips">获得全球一等奖，二等奖，三等奖，优秀奖，新星奖及最佳创意奖的参赛作品的版权。</span><br />
          <span class="requirementTips">（包括但不限于复制权、发行权、出租权、展览权等权利）转让给主办方，归主办方所有。</span><br />



          <img style="width:98px;height: 134px; margin-top: 40px;" src="@/assets/2026img/task/logo.png" alt="" />
        </div>
          </div>
        </div>

      </div>
         <div>

        <div v-if="locale === 'zh'" class="introduce-title3">
          <div class="title1">「HMI赛道」</div>
          <!-- <div class="title2">Needs and minds</div> -->
          <img style="width:580px;height: 232px; margin-top: 20px;" src="@/assets/2026img/task/year.png" alt="" />
          <div class="title2" style="font-weight: 700;">《共振界面 · 感性交互》</div>
        </div>
        <div class="submission-content">
          <div v-if="locale === 'zh'" class="introduce-title4">

            <p class="title3"> &nbsp;&nbsp;&nbsp;&nbsp;
           智能座舱的核心，已超越基础的驾驶功能，演进为构建更深层次的 “人车共生”关系。本赛道邀请您共同探索这一前沿：以 “情感化IP伙伴” 作为座舱的智能与情感中枢，让它不仅是交互的入口，更是懂你、陪伴你的旅伴。
       请您深入挖掘MG品牌基因与用户情感需求，以IP形象MOLI为核心切入点，并以其贯穿整个HMI系统，通过UI界面为核心，系统性的讲述一个完整，共鸣的体验设计方案。
            </p>
            <p class="title3" style="width: 100%;" > &nbsp;&nbsp;&nbsp;&nbsp; 作品需涵盖以下核心模块中至少四个进行视觉与交互设计，以仪表、中控、Phud为载体呈现（紫色必选）：动态壁纸、IP世界观、成长体系&玩法、IP互动设计、图标体系、上车&下车动画、智能场景（充电、小憩、哨兵模式...）、智舱联动设计、PHUD设计。 </p>
            <p class="title3" style="width: 100%;" > &nbsp;&nbsp;&nbsp;&nbsp; 赛道欢迎使用AI作为助力工具，期待看到IP人格如何与用户情感共振，塑造独一无二的座舱体验。 </p>
            <p class="title3" style="width: 100%;" > &nbsp;&nbsp;&nbsp;&nbsp; MG MOLI（以品牌IP MOLI为固定形象延展设计） </p>

        
            <div class=" requirement ">
              <div class="title1">作品提交内容及要求</div>
              <div class="title2">Submission Content and Requirements for Works</div>
            </div>
            <div class="item-box">

              <div>
                <span class="item-bold">1、个人介绍： </span> <br />


                <span class="requirementTips"> 100秒内自我介绍MP4视频*1，简历pdf*1。</span><br />

              </div>
            </div>
            <div class="item-box lineHeight">
              <div>
                <span class="item-bold">2、UI设计效果图：</span><br />
                <span class="requirementTips">仪表1920*480，中控1920*1080，JPG/PNG/MP4/MOV格式。</span>
              </div>
            </div>
            <div class="item-box lineHeight">
              <div>
                <span class="item-bold">3、设计概念：</span><br />
                <span class="requirementTips">pptx格式，单页16:9。包含设计理念，交互概念，亮点解读。如若涉及功能，需清晰展示用车场景及流程。</span>
               <span class="requirementTips">注意元素内嵌，尺寸需要手机阅读舒适，比例适宜，字体清晰可读，AI生成内容需要在PPT尾页注明。</span>
              </div>
            </div>
             <div class="item-box lineHeight">
              <div>
                <span class="item-bold">4、宣传视频：</span><br />
                <span class="requirementTips">不超过3分钟，不超过500m。</span>
              </div>
            </div>
           <div class="item-box lineHeight">
              <div>
                <span class="item-bold">5、额外展示作品：</span><br />
                <span class="requirementTips">任何参赛选手想要额外上传展示的附加内容。个人网站/作品模型/可操作原型/appendix/动效…格式不限，但建议能友好查阅。</span>
              </div>
            </div>
             <div v-if="locale === 'zh'" class="requirement">
          <div class="title1">版权申明</div>
          <div class="title2" style="margin-bottom: 40px;">Copyright Statement</div>
        </div>
        <div class="item-box lineHeight">
          <span class="requirementTips">您需确保您的作品为原创作品，且未被授权给任何组织或个人商用（不论有偿或无偿）。</span><br />
          <span class="requirementTips">本次比赛不接受在其他比赛中投稿的作品参赛。</span><br />
          <span class="requirementTips">主办方对在本次大赛中所提供的所有参赛作品均享有合法使用权益，参赛者一旦参赛，则视为同意并授权主办方及其关联公司自投稿之日起至大赛结束以后无偿地在全球范围内将其投稿作品用于活动和产品、品牌宣传，包括但不限于将作品用于全媒体平台、艺术展会，零售店以及路演等营销活动，据此使用参赛作品时不需要再另行通知参赛者或征得参赛者的同意。</span><br />
          <span class="requirementTips">主办方及其关联公司有权基于以上目的授权合作方使用投稿作品。</span><br />
          <span class="requirementTips">获得全球一等奖，二等奖，三等奖，优秀奖，新星奖及最佳创意奖的参赛作品的版权。</span><br />
          <span class="requirementTips">（包括但不限于复制权、发行权、出租权、展览权等权利）转让给主办方，归主办方所有。</span><br />



          <img style="width:98px;height: 134px; margin-top: 40px;" src="@/assets/2026img/task/logo.png" alt="" />
        </div>
          </div>
        </div>

      </div>
  
    </div>
    <div>
       <img style="width:100%;" src="@/assets/2026img/task/integrateKV.png" alt="" />

       <div class="integrate-content">
      <div  class="integrate-title">
       
        <div class="title1">参赛方式</div>
        <div class="title2">Proposition Boundaries & Design Principles</div>
        <div class="title3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 以学校为战队向SDC组委会提交申请，每个战队可含多个小组。可小组参赛，可单人成组参赛，每小组不超过4人。不限专业，支持非设计类选手参赛。各战队最终派出1支小组代表学校参加决赛。</div>
        <div class="title4">产出要求</div>
        <div class="title3">   创新融合赛道欢迎具备设计思维的跨学科背景设计师参与，基于赛道命题完成洞察、发散研究、设计收束、成果产出的完整项目流程。
小组参赛同样鼓励多样的角色为团队赋能，产出形式不限，以设计思维为底，参赛者可以选择造型设计、服务设计、交互设计、材料设计、系统设计、可视化设计等设计形式完成最终的落地产出。 </div>
      
      </div>
      <div  class="integrate-request">
        <div class="title1">作品提交内容及要求</div>
        <div class="title2">Submission Content and Requirements for Works</div>
        <div class="title5">在各学校战队中我们将与校方指导老师共同评选出最佳作品入选上汽设计国际挑战赛闭幕式及颁奖典礼，入选团队需提供</div>
        <div class="title6">1、（小组）自我介绍：</div>
        <div class="title7">100秒自我介绍MP4视频*1，简历每个成员各一份pdf*1。 </div>
        <div class="title6">2、PPT：</div>
        <div class="title7">需包含设计背景、设计内容、设计解析及成果展现 </div>
         <div class="title6">3、展板：</div>
        <div class="title7">需包含设计背景、设计意图、设计解析及成果展现 </div>
          <div class="title6">4、视频：</div>
        <div class="title7">需清晰体现设计理念、设计语境及设计目标。不超过150秒，不大于2G。 </div>
         <div class="title6">5、原型：</div>
        <div class="title7">可互动体验Booth，形式不限。 </div>
      </div>

       <div  class="integrate-request">
       
        <div class="title1">版权申明</div>
        <div class="title2">Copyright Statement</div>
      
          <span class="title7">您需确保您的作品为原创作品，且未被授权给任何组织或个人商用（不论有偿或无偿）。</span>
          <span class="title7">本次比赛不接受在其他比赛中投稿的作品参赛。</span>
          <span class="title7">主办方对在本次大赛中所提供的所有参赛作品均享有合法使用权益，参赛者一旦参赛，则视为同意并授权主办方及其关联公司自投稿之日起至大赛结束以后无偿地在全球范围内将其投稿作品用于活动和产品、品牌宣传，包括但不限于将作品用于全媒体平台、艺术展会，零售店以及路演等营销活动，据此使用参赛作品时不需要再另行通知参赛者或征得参赛者的同意。</span>
          
          <span class="title7">主办方及其关联公司有权基于以上目的授权合作方使用投稿作品。</span>
          <span class="title7">获得全球一等奖，二等奖，三等奖，优秀奖，新星奖及最佳创意奖的参赛作品的版权。</span>
          <span class="title7">（包括但不限于复制权、发行权、出租权、展览权等权利）转让给主办方，归主办方所有。</span>
          <img style="width:98px;height: 134px; margin-top: 40px;" src="@/assets/2026img/task/integrateLogo.png" alt="" />
       
      
      </div>
   </div>
      
      
    </div>
    <div>
    
      <div v-if="locale === 'zh'" class="introduce-title6">
        <div class="title1">专家评审团</div>
        <div class="title3">Expert Jury</div>
      
      </div>
      <div class="advertising-img">
        <img style="width: 1250px" src="@/assets/2026img/task/user.png" alt="" />
      </div>

    </div>
    <div class="TimeArrangement">
      
      <div v-if="locale === 'zh'" class="introduce-title7">
        <div class="title1">赛程时间（暂定）</div>
        <div class="title3">Time Arrangement (Provisional)</div>
      </div>
      <div class="advertising-img">
        <img style="width: 1080px" src="@/assets/2026img/task/schedule.png" alt="" />
      </div>
    </div>
    <div class="submission-content">
   
      <div v-if="locale === 'zh'" class="introduce-title8">
        <div class="title1">大赛作品提交方式</div>
        <div class="title3">Submission Approach</div>
      </div>
      <div class="submission-title ul-item-box">
        <p>
          <span style="font-weight: 700;">{{ $t("CompetitionText181") }}</span><span>{{ $t("CompetitionText182") }}</span>
        </p>
        <p>
          <span style="font-weight: 700;" >{{ $t("CompetitionText183") }}</span>
        </p>
        <p>
          <span style="font-weight: 700;" >{{ $t("CompetitionText184") }}</span><span>{{ $t("CompetitionText185") }}</span>
        </p>
        <p>
          <span style="font-weight: 700;">{{ $t("CompetitionText186") }}</span>
        </p>
        <p>
          <span style="font-weight: 700;" >{{ $t("CompetitionText187") }}</span><span>{{ $t("CompetitionText188") }}</span>
        </p>
      </div>
      <p v-if="locale === 'en'" class="submission-title">
        Mail：saicdesign@saicmotor.com
      </p>
    </div>
    <a-image v-if="data.current" :style="{ display: 'none' }" :preview="{ visible, onVisibleChange: handleDrawer }"
      :src="data.current" :alt="data.title" />
    <!-- <div class="advertise-box">
      <img
        v-for="(item, index) in 4"
        :key="index"
        @click="
          hDrawer(data.resOther.data[item + 6][imageType], $t('Introduction'))
        "
        :src="data.resOther && data.resOther.data[item + 6][imageType]"
        style="cursor: pointer"
      />
    </div> -->
  </div>
</template>

<script setup>
import videoPc from "@/components/video-PC.vue";
import API from "../api/index.js";
import {
  reactive,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  ref,
  computed,
  nextTick,
} from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";
const { t, locale } = useI18n();
const props = defineProps({
  isLang: {
    type: Boolean,
    default: true,
  },
  videoSrc: {
    type: String,
    default: "",
  },
});

const visible = ref(false);
const data = reactive({
  commonVideoSrc: "",
  resOther: null,
  current: null,
  images: [{ src: "" }],
  backgroundImage1: "",
  backgroundImage2: "",
  backgroundImage3: "",
  backgroundImage4: "",
  backgroundImage5: "",
  backgroundImage6: "",
  backgroundImage7: "",
  stepsList: [
    {
      zhTime: "3月31日",
      zhText: "任务书发布",
      enTime: "Mar .31st",
      enText: "Mission Statement Announced",
    },
    {
      zhTime: "4月1日",
      zhText: "赛事正式启动",
      enTime: "Apr.1st",
      enText: "Start of Competition",
    },
    {
      zhTime: "6月上旬",
      zhText: "初赛作品征集提交截止",
      enTime: "Early Jun.",
      enText: "Deadline for Submission",
    },
    {
      zhTime: "6月中旬",
      zhText: "发布入围选手名单及作品",
      enTime: "Mid Jun.",
      enText: "Shortlist of Works Released",
    },
    {
      zhTime: "6月下旬",
      zhText: "公布全球入围实习名单",
      enTime: "Late Jun.",
      enText: "Intern List Released",
    },
    {
      zhTime: "7月-8月",
      zhText: "入围选手实习",
      enTime: "Jul.-Aug. ",
      enText: "Start of Internship",
    },
    {
      zhTime: "9月",
      zhText: "模型制作",
      enTime: "Sep.",
      enText: "Model Making",
    },
    {
      zhTime: "10月中下旬",
      zhText: "全球颁奖仪式",
      enTime: "Mid-late Oct.",
      enText: "Global Awards Ceremony",
    },
  ],
  isLoading: false,
});

// const imageType = ref(sessionStorage.getItem("SAIC-DESIGN-IMAGETYPE"));

const fetchVideoSrc = () => {
  API.requestVideo({
    objectName:
      "SAIC_Design/dev/index/我是汽车设计师-16-9外发版本黑底笑脸墙.m4v",
  }).then((res) => {
    data.commonVideoSrc = res.data["extranetUrl"];
  });
};
const showFn = (src) => {
  data.current = src;
  visible.value = true;
};
// 抽屉
const handleDrawer = (src, title) => {
  nextTick(() => {
    data.current = src;
    data.title = title;
    visible.value = true;
  });
};
const getOther = async () => {
  const res = await API.requestImage({
    fileDirUrl: "SAIC_Design/prod/other/",
  }).catch((e) => e);
  data.resOther = res.data;
  console.log("local", locale);
  data.backgroundImage1 =
    locale.value === "en"
      ? data.resOther[33]["extranetUrl"]
      : data.resOther[25]["extranetUrl"];
  data.backgroundImage2 = data.resOther[31]["extranetUrl"];
  data.backgroundImage3 = data.resOther[30]["extranetUrl"];
  data.backgroundImage4 = data.resOther[28]["extranetUrl"];
  data.backgroundImage5 = data.resOther[36]["extranetUrl"];
  data.backgroundImage6 = data.resOther[40]["extranetUrl"];
  data.backgroundImage7 = data.resOther[41]["extranetUrl"];
};

// 下载事件
const hDownload = () => {
  data.isLoading = true;
  let reqInstance = axios.create({
    // params: { apikey: 'bh42rxK05xklU6gs3IFSVYmR007IOQ1c' },
    headers: { loginName: "123" },
  });
  const config = {
    responseType: "blob", //这个一定要设置，否则会出现文件下载后打不开的情况
  };
  reqInstance
    .post(
      // "https://api-at.saicmotortest.com/vpdp/mobile/dev/v1/design/oss/file/oss/download",
      "/design/oss/file/oss/download",
      {
        ossFilePath: "SAIC_Design/prod/document/各赛道参考案例及赛事logo.zip",
      },
      config
    )
    .then((res) => {
      // const blob = new Blob(res, {
      const blob = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      let objectUrl = URL.createObjectURL(blob); //创建下载的链接
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = "各赛道参考案例及赛事logo.zip"; //设置文件名
      // a.download = "赛事资料.xlsx"; //设置文件名
      //下面这个写法兼容火狐
      a.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
      window.URL.revokeObjectURL(blob); //释放bolb对象
    })
    .then((e) => {
      data.isLoading = false;
    })
    .catch((err) => {
      data.isLoading = false;
    });
};

onMounted(() => {
  fetchVideoSrc();
  getOther();
});
</script>

<style lang="less" scoped>
@comMargin: 48px auto;
@comPadding: 0 7%;
@buttonColor: #9effc0;
@subButtonColor: #476dec;
@media screen and (min-width: 751px) {
  .task-box {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;

    h2 {
      font-size: 32px;
      font-weight: 700;
      margin: 10px 0 !important;
      text-align: center;
    }

    .introduce-video-box,
    .introduce-box,
    .submission-content,
    .sub-content {
      width: 75%;
      margin: 0 auto;
    }

    .introduce-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: @comPadding;

      // margin: @comMargin;
      .introduce-title {
        // width: 400px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: @comPadding;
        margin: @comMargin;
        color: #ffffff;

        .title1 {
          // width: 400px;
          // background-color: @buttonColor;
          color: #DF3021;
          text-align: center;
          font-family: "Alibaba PuHuiTi";
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }

        .title2 {
          // width: 379px;
          background-color: @subButtonColor;
          color: #fff;
          font-size: 18px;
          padding: 0 10px;
          letter-spacing: 2px;
        }

        .title3 {
          // width: 379px;
          color: @subButtonColor;
          font-size: 28px;
          padding: 0 10px;
        }

        .title4 {
          // width: 477px;
          background-color: @buttonColor;
          font-size: 18px;
          font-weight: bold;
          padding: 0 10px;
        }

        .title5 {
          // width: 367px;
          background-color: @subButtonColor;
          font-size: 32px;
          font-weight: bold;
          padding: 0 10px;
        }
      }
    }

    .advertising-img {
      // padding: 405px 0;
      width: 100%;
      text-align: center;

      // background: repeat-x 0px 0px/100% 100%, repeat-x 0px 0px/100% 100%;
      img {
        width: 1080px;
      }
    }

    .car-img {
      width: 100%;
      margin-bottom: 10px;
    }

    .item-bold {
      display: inline-block;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      margin-top: 40px
    }

    .item-liner {
      width: 100%;
      height: 41px;
      line-height: 41px;
      background-color: #fb3995;
      color: #ffffff;
      margin: 60px 0 0 0;
      text-align: center;
      font-size: 32px;
    }

    .sub-content {
      padding: @comPadding;
      margin: @comMargin;
    }

    .submission-content {
      // padding: 0 2%;
      margin: 0 auto 40px;

      // line-height: 28px;
      .en-title {
        // position: relative;
        width: 75%;
        height: 24px;
        margin: 20px auto 0;
        background: #c5f946;
        text-align: center;

        span {
          display: block;
          transform: translateY(-50%);
          font-size: 20px;
        }
      }

      .submission-title {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        // font-weight: bold;
        font-size: 14px;
        color: #476dec;
        line-height: 24px;
        color: #E34B4C;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 16px;
font-style: normal;

line-height: 24px; /* 150% */

      }

      .item-box {
        color: #000;
        text-align: center;
        line-height: 32px;

        /* 177.778% */
        h5 {
          font-weight: 700;
          margin-bottom: 5px !important;
        }

        p {
          padding: 0 0 0 1em;
          line-height: 28px;
        }
      }

      .ul-item-box {
        h5 {
          font-weight: 600;
          margin-bottom: 5px !important;
        }

        p {
          line-height: 28px;
        }
      }

      .dl-item-box {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        h5 {
          font-weight: 600;
        }

        p {
          line-height: 28px;
        }
      }

      .steps {
        display: flex;
        align-items: center;
        height: 400px;
        width: 100%;

        .steps-wire {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 2px;
          width: 100%;
          background: rgba(113, 173, 73, 0.3);

          .steps-node {
            width: 12px;
            height: 12px;
            background: #71ad49;
            border-radius: 6px;
            border: 2px solid #fff;
            margin-right: 11.5%;

            .text {
              margin-top: 23px;
              display: flex;
              flex-direction: column;

              p,
              h4 {
                white-space: nowrap;
                margin: 0 !important;
                font-size: 14px;
              }

              p {
                font-size: 12px;
              }
            }
          }

          .steps-node:nth-of-type(1) {
            .text {
              margin-left: -20px;
            }
          }

          .steps-node:nth-of-type(2n) {
            .text {
              margin-top: -100px;
            }
          }
        }
      }

      .tips {
        font-weight: 700;
        display: block;
        margin-top: 28px;
      }
    }

    /deep/.ant-btn-primary {
      background: rgba(26, 26, 26, 1);
      border: transparent;
      //       display: flex;
      // padding: 9px 40px;
      // justify-content: center;
      // align-items: center;
      // border-radius: 44px;

    }

    /deep/.ant-btn-primary:hover {
      background-color: #7d983a;
    }

    /deep/.ant-btn-primary:active {
      background: #527104;
    }
  }

  h4 {
    font-size: 20px;
    margin: 30px 0 30px 0 !important;
    font-weight: 700;
  }

  h5,
  p {
    font-size: 14px;
    // font-family: "AalibabaPuHui-B";
  }

  .warn {
    color: #ee0000;
    margin-right: 3px;
  }

  .item-box,
  .ul-item-box {
    margin-bottom: 16px;
  }
}

.introduce-title1 {
  // width: 441px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    display: flex;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #E34B4C;
    color: #FFFEFE;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    /* 142.857% */
  }

  .title2 {
    // width: 314px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;

  }

  .title3 {
    // width: 314px;
    color: #E34B4C;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 24px;
    font-style: normal;
 
    line-height: normal;
    font-weight: 400;
  }

  .title4 {
    width: 441px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    width: 279px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title2 {
  // width: 417px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    // width: 211px;
    display: flex;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #E34B4C;
    color: #FFFEFE;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    /* 142.857% */
  }

  .title2 {
    // width: 411px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;
  }

  .title3 {
    color: #E34B4C;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .title4 {
    // width: 417px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    // width: 343px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title3 {
  // width: 458px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  margin-top: 96px;
  color: #ffffff;

  .title1 {
    // width: 211px;
    color: #DF3021;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .title2 {
    // width: 365px;
    color: #E34B4C;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 20px;
  }

  .title3 {
    // width: 365px;
    background-color: @subButtonColor;
    font-size: 28px;
    padding: 0 10px;
  }

  .title4 {
    width: 458px;
    background-color: @buttonColor;
    font-size: 18px;
  }

  .title5 {
    // width: 316px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title4 {
  // width: 401px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    // width: 345px;
    color: #E34B4C;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

  }

  .title2 {
    color: #000;
    font-family: "Alibaba PuHuiTi";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    /* 222.222% */
    text-align: left !important;
    margin-top: 24px;
  }

  .title3 {
    // width: 274px;
    color: #000;
    font-family: "Alibaba PuHuiTi";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    /* 222.222% */
    text-align: left !important;
    list-style: disc !important;

  }

  .title4 {
    // width: 339px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    // width: 401px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title5 {
  // width: 274px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    // width: 211px;
    background-color: @buttonColor;
    color: #476dec;
    font-size: 32px;
    padding: 0 10px;
    font-weight: bold;
  }

  .title2 {
    // width: 274px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;
  }

  .title3 {
    // width: 274px;
    background-color: @subButtonColor;
    font-size: 28px;
    padding: 0 10px;
  }

  .title4 {
    // width: 179px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    // width: 274px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title6 {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin-top: 48px;
  margin-bottom: 48px;
  // margin-left: -0.2%;
  color: #ffffff;

  .title1 {
    // width: 27%;
    // background-color: @buttonColor;
    display: flex;
padding: 0 10px;
justify-content: center;
align-items: center;
gap: 10px;
color: #FFF;
font-family: "Alibaba PuHuiTi";
font-size: 30px;
font-style: normal;
font-weight: 700;
line-height: normal;
background: #EA3323;
  }

  .title2 {
    // width: 27%;
    // background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;
  }

  .title3 {
    // width: 27%;
    // background-color: @subButtonColor;

 display: flex;
padding: 0 10px;
justify-content: center;
align-items: center;
gap: 10px;
color: #E34B4C;
font-family: "Alibaba PuHuiTi";
font-size: 18px;
font-style: normal;

line-height: normal;
background: #F9CEC2;
padding: 2px 35px;
  }

  .title4 {
    // width: 22%;
    // background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    // width: 27%;
    // background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }

  .title6 {
    // width: 27%;
    white-space: nowrap;
    text-align: center;
    color: #476dec;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 12px;
    padding: 0 10px;
  }
}

.introduce-title7 {
  // width: 333px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    // width: 333px;
     display: flex;
padding: 0 25px;
justify-content: center;
align-items: center;
gap: 10px;
color: #FFF;
font-family: "Alibaba PuHuiTi";
font-size: 30px;
font-style: normal;
font-weight: 700;
line-height: normal;
background: #EA3323;
  }

  .title2 {
    // width: 333px;
    background-color: @subButtonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;
  }

  .title3 {
    // width: 333px;
   display: flex;
padding: 0 10px;
justify-content: center;
align-items: center;
gap: 10px;
color: #E34B4C;
font-family: "Alibaba PuHuiTi";
font-size: 18px;
font-style: normal;

line-height: normal;
background: #F9CEC2;

  }

  .title4 {
    // width: 333px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    // width: 268px;
    background-color: @subButtonColor;
    font-size: 32px;
    padding: 0 10px;
  }
}

.introduce-title8 {
  // width: 305px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @comPadding;
  margin: @comMargin;
  color: #ffffff;

  .title1 {
    // width: 305px;
        display: flex;
padding: 0 10px;
justify-content: center;
align-items: center;
gap: 10px;
color: #FFF;
font-family: "Alibaba PuHuiTi";
font-size: 30px;
font-style: normal;
font-weight: 700;
line-height: normal;
background: #EA3323;
  }

  .title2 {
    // width: 305px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
    letter-spacing: 2px;
  }

  .title3 {
    // width: 305px;
         display: flex;
padding: 0 34px;
justify-content: center;
align-items: center;
gap: 10px;
color: #E34B4C;
font-family: "Alibaba PuHuiTi";
font-size: 18px;
font-style: normal;
line-height: normal;
background: #F9CEC2;
  }

  .title4 {
    // width: 243px;
    background-color: @buttonColor;
    font-size: 18px;
    padding: 0 10px;
  }

  .title5 {
    padding: 0 10px;
    background-color: @subButtonColor;
    font-size: 32px;
  }
}

.button-type5 {
  display: flex;
  padding: 9px 40px;
  justify-content: center;
  align-items: center;
  border-radius: 44px;

  background-color: #E34B4C !important;
  color: #ffffff !important;

}

.button-type5:hover {
  background-color: #FF6E6F !important;
  color: #ffffff !important;

}

.button-type5:active {
  background-color: #D93637 !important;
  color: #ffffff !important;

}

.localeEn {
  .submission-content>div:nth-child(1) {
    font-weight: bold;
  }

  .submission-content>div:nth-child(2) {
    font-weight: bold;
  }

  div,
  p,
  span {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  }
}

.localeZh {

  div,
  p,
  span {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  }
}

.evaluationBox {
  display: flex;
  justify-content: center;
  flex-direction: column;
  display: grid;

  span {

    text-align: center;
    color: #000;
    font-family: "Alibaba PuHuiTi";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    background-color: #fff;

    span {
      color: #000;
      text-align: center;
      font-family: "Alibaba PuHuiTi";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      /* 200% */
    }
  }

}

.TimeArrangement {
  margin-left: 10px;
  margin-top: 30px;
}

.articleText {

  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.lineHeight {
  line-height: 28px;
}
.headTitleBox{
  position: absolute;
  width: 100%;
  height: 60px;
  line-height: 60px;
 padding-top: 13px;
  
   border-radius: 20px 20px 0 0;
background: rgba(255, 255, 255, 0.40);
backdrop-filter: blur(5px);
}
.headTitle {
  display: flex;
  justify-content: space-between;
  margin: 0 80px;
}

.titleTips {
  color: #000;
  font-family: "Alibaba PuHuiTi";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.box{
 height: 60px;
 width: 100%;

}
.bgcKV {
 
margin-top: 60px;

  background-image: url("../assets/2026img/task/bgcKV.png");
  background-repeat: no-repeat;
  /* 禁止背景图重复（默认重复） */
  background-size: cover;
  /* 覆盖整个元素，保持比例（常用：cover/contain/100% 100%） */

}

.theme-content {
  display: flex;

  flex-direction: column;
  align-items: center;
  gap: 20px;

  color: #000;
  text-align: center;
  font-family: "Alibaba PuHuiTi";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;

}

.requirement {
  display: flex;

  flex-direction: column;
  align-items: center;
  margin-top: 40px;


  .title1 {
    display: flex;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #E34B4C;
    color: #FFFEFE;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    /* 142.857% */
  }

  .title2 {
    color: #E34B4C;
    text-align: center;
    font-family: "Alibaba PuHuiTi";
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin-top: 0 !important;
  }
}

.item-box {
  .requirementTips {
    display: inline-block;
    // padding: 0 10px;
    color: #000;
    text-align: center;
    font-size: 16px;
    font-weight: 400 !important;
    margin-top: 0px !important;
    background-color: #fff;

    .bold {
      color: #000;
      text-align: center;
      font-family: "Alibaba PuHuiTi";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      /* 200% */
    }
  }
}

.bold {
  color: #000;
  text-align: center;
  font-family: "Alibaba PuHuiTi";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  /* 200% */
}
.subtitle{
  color: #E34B4C;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 200% */
}
.integrate-content{
  padding: 0 11%;
   margin: 0 auto 48px;
.integrate-title{
  width: 100%;
  padding: 0 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
 
}
.integrate-request{
   width: 100%;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;

}
    .title1{
   
height: 40px;
color: #FFFEFE;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 28px;
font-style: normal;
font-weight: 700;
line-height: 40px; /* 142.857% */
background: #3682F6;
display: flex;
padding: 0 12px;
justify-content: center;
align-items: center;
gap: 10px;

  }
  .title2{
color: #327FF6;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 24px;
font-style: normal;
font-weight: 300;
line-height: normal;
margin-bottom: 40px;
background: #EAF0F5;
padding: 0 12px;
  }
  .title3{
    width: 100%;
    text-align: left;
    line-height: 32px; /* 133.333% */
    font-size: 18px;
  }
  .title4{
    margin: 40px 0;
    color: #000;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 133.333% */
  }
  .title5{
color: #000;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 177.778% */
  }
  .title6{
    color: #000;
text-align: center;
font-family: "Alibaba PuHuiTi";
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 177.778% */
margin-top: 24px;
  }
   .title7{
    width: 100%;
    text-align: center;
    line-height: 32px; /* 133.333% */
    font-size: 16px;
  }
    .title8{
    width: 100%;
    text-align: center;
  
  }
}
       .text-underline {
            /* 核心：设置下划线 + 下划线颜色（可和文字颜色不同） */
            text-decoration: underline; /* 显示下划线 */
            text-decoration-color: #f5c142; /* 下划线颜色（红色） */
            text-decoration-thickness: 4px; /* 下划线粗细（可选） */
            text-underline-offset: 0px; /* 下划线和文字的间距（可选，避免贴太紧） */
               text-decoration-skip-ink: none;
            /* 可选：禁止下划线跳过空白/标点 */
            text-decoration-skip: none;
            
           
        }
</style>
      